import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

export const DEFAULT_SETTINGS = {
  shop_address: "[Indirizzo del negozio]",
  shop_phone: "[Telefono]",
  shop_vat: "[P.IVA]",
  shop_email: "",
  hero_line1: "Il futuro",
  hero_line2: "nelle tue",
  hero_line3: "mani.",
  hero_subtitle: "Gli smartphone e gli accessori che contano, scelti uno per uno. Compra online con carta o chiedici un preventivo: ti rispondiamo noi, persone vere.",
  featured: null,
};

const Ctx = createContext({ settings: DEFAULT_SETTINGS, setSettings: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  useEffect(() => {
    http.get("/settings").then((r) => setSettings({ ...DEFAULT_SETTINGS, ...(r.data || {}) })).catch(() => null);
  }, []);
  return <Ctx.Provider value={{ settings, setSettings }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
